import { StyleSheet, Platform } from "react-native";
import { fonts } from "../../styles/theme";

const EmulateUserStyle = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
    paddingHorizontal: 10,
    paddingVertical: 20,
  },
  header: {
    paddingVertical: 20,
  },
  headerText: {
    fontSize: 22,
    //fontWeight: "600",
    paddingLeft: 10,
    fontFamily: fonts.regular,
    marginLeft: 7,
  },
  content: {
    flex: 1,
  },

  autoCompleteContainer: {
    width: "100%",
    paddingHorizontal: 10,
    position: "relative",
  },

  suggestionsList: {
    position: "absolute",
    top: Platform.OS === "ios" ? 83 : 100,
    left: 0,
    right: 0,
    backgroundColor: "#FFF",
    borderRadius: 15,
    maxHeight: 500,
    borderColor: "#CCC",
    borderWidth: 1,
    zIndex: 1000,
    overflow: "hidden",
    marginHorizontal: 10,
  },

  // suggestionsList: {
  //   backgroundColor: "#FFF",
  //   borderRadius: 15,
  //   maxHeight: 530,
  //   borderColor: "#CCC",
  //   borderWidth: 1,
  //   zIndex: 1000,
  //   marginHorizontal: 10,
  //   marginTop: 10,
  // },

  label: {
    fontSize: 16,
    //fontWeight: "600",
    marginBottom: 10,
    paddingLeft: 5,
    fontFamily: fonts.regular,
  },
  input: {
    minHeight: Platform.OS === "ios" ? 80 : 100,
    borderWidth: 1,
    borderRadius: 15,
    paddingHorizontal: 15,
    backgroundColor: "#FFF",
    fontSize: 16,
    fontFamily: fonts.regular,
    marginLeft: 5,
    marginRight: 5,
    lineHeight: Platform.OS === "android" || Platform.OS === "web" ? 28 : 0,

    textAlignVertical: "center",
    includeFontPadding: false,
  },

  defaultBorder: {
    borderColor: "#ccc",
  },
  focusedBorder: {
    borderColor: "blue",
  },

  option: {
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#EEE",
  },
  optionText: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  button: {
    marginTop: 35,
    paddingVertical: 20,
    borderRadius: 15,
    alignItems: "center",
    marginLeft: 5,
    marginRight: 5,
  },
  buttonText: {
    color: "#FFF",
    fontSize: 20,
    //fontWeight: "bold",
    fontFamily: fonts.medium,
  },
  emailText: {
    fontSize: 13,
    fontFamily: fonts.medium,
  },

  // card: {
  //   backgroundColor: "white",
  //   borderRadius: 19,
  //   marginLeft: 10,
  //   marginRight: 10,
  //   paddingBottom: 40,
  //   paddingTop: 20,
  //   shadowColor: "gray",
  //   shadowOffset: {
  //     width: 0,
  //     height: 0,
  //   },
  //   shadowOpacity: 0.2,
  //   shadowRadius: 8,
  //   elevation: 10,
  // },

  errorContainer: {
    marginTop: 10,
    alignItems: "center",
  },
  errorText: {
    color: "red",
    fontSize: 14,
    fontFamily: fonts.regular,
  },

  inputContainer: {
    position: "relative",
    justifyContent: "center",
    width: "100%",
  },

  clearIcon: {
    position: "absolute",
    right: 10,
    height: "90%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: 15,
    paddingRight: 3,
  },
  noResultsContainer: {
    padding: 15,
    borderWidth: 1,
    borderColor: "#E0E0E0",
    borderRadius: 15,
    marginTop: 10,
    marginHorizontal: 5,
    marginBottom: -25,
  },
  noResultsText: {
    color: "#666",
    textAlign: "center",
    fontSize: 14,
    fontFamily: fonts.regular,
  },
});

export default EmulateUserStyle;
